import React, { memo, FC, useEffect } from 'react';
import { ToolType } from '../tools.types';
import { classNameMerge } from '../../../utils/classNameMerge';
import cls from './ToolsList.module.scss';
import ToolsListHeader from '../ToolsListHeader';
import { Button } from 'react-bootstrap';
import ToolPreviewItem from '../ToolPreviewItem';
import Spinner from '../../../UIComponents/Spinner';

type ToolsListProps = {
  tools: ToolType[] | undefined;
  className?: string;
  isLoading: boolean;
  scrollTools: ToolType[];
  setScrollTools: React.Dispatch<React.SetStateAction<ToolType[]>>;
  maxPages: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  page: number;
};

const ToolsList: FC<ToolsListProps> = memo((props) => {
  const { tools, className, isLoading, scrollTools, setScrollTools, maxPages, page, setPage } =
    props;
  const reloadHandler = () => {
    window.location.reload();
  };
  const refreshHandler = () => {
    setScrollTools([]);
    setPage(0);
  };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const scrollHandler = (event: any) => {
    if (
      document.querySelector('.tools-list')?.clientHeight + event.target.scrollTop ===
        event.target.scrollHeight &&
      page + 1 < maxPages
    ) {
      setPage(page + 1);
    }
  };
  useEffect(() => {
    if (tools && tools?.length !== 0) {
      const uniqueSolutions = tools.filter(
        (user) => !scrollTools.some((item) => item.id === user.id),
      );
      setScrollTools([...scrollTools, ...uniqueSolutions]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tools]);
  if (isLoading)
    return (
      <div className={classNameMerge(cls.ListEmpty, className)}>
        <Spinner />
      </div>
    );
  if (!isLoading && tools?.length === 0) {
    <div className={classNameMerge(cls.ListEmpty, className)}>
      <div className={cls.EmptyText}>
        <h2 className="title-2">No tools yet</h2>
        <p className={cls.Text}>Try again later or refresh the page</p>
        <Button onClick={reloadHandler} className={cls.Button}>
          Refresh page
        </Button>
      </div>
    </div>;
  }
  return (
    <div className={classNameMerge(cls.List, className)}>
      <ToolsListHeader />
      <div className={`${cls.Tools} tools-list`} onScroll={scrollHandler}>
        {scrollTools?.map((tool) => (
          <ToolPreviewItem key={tool.id} tool={tool} refreshHandler={refreshHandler} />
        ))}
      </div>
    </div>
  );
});

export default ToolsList;
